module.exports = __webpack_public_path__ + "static/bladesinger-82c9364573ba2bf969f208c32352bad2.png";